require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./services-photo-video-micro-video.json") })
        }
      }, "path---services-photo-video-micro-video");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---services-photo-video-micro-video!./.cache/json/services-photo-video-micro-video.json
// module id = 760
// module chunks = 231608221292675